// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2QNusZ1MgLGklGjU_62vMu5kQNlnQaNg",
  authDomain: "cory-sat.firebaseapp.com",
  projectId: "cory-sat",
  storageBucket: "cory-sat.appspot.com",
  messagingSenderId: "360082914870",
  appId: "1:360082914870:web:3ed3c7976fd307bcb62297",
  measurementId: "G-395SPGZ1KN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);
export const db = getFirestore(app);